import image from 'shared/assets/images/integrationsSliders/asana/asana.png'
import { LINK_AMPERSAND_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const asana: IntegrationDetailsData = {
  subheadline: 'Keep your project management and team communication perfectly aligned.',
  overview:
    'Connect Salesmsg with Asana to streamline your workflow and keep your project management data up to date. When you engage with contacts through Salesmsg, relevant information flows to Asana, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and project management workflows',
  ],
  images: [image],
  docs: LINK_AMPERSAND_INTEGRATION_GUIDE,
}
